import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationsApi } from '../services/notifications';
import { getIdentityScope } from '../stores/useAuthStore';

// Scoped to the active identity - notifications are per user
export const notificationKeys = {
  all: ['notifications'] as const,
  scoped: () => [...notificationKeys.all, getIdentityScope()] as const,
  list: () => [...notificationKeys.scoped(), 'list'] as const,
  unreadCount: () => [...notificationKeys.scoped(), 'unread-count'] as const,
};

export function useNotifications() {
  return useQuery({
    queryKey: notificationKeys.list(),
    queryFn: async () => {
      const res = await notificationsApi.list();
      return res.data;
    },
  });
}

export function useUnreadCount() {
  return useQuery({
    queryKey: notificationKeys.unreadCount(),
    queryFn: async () => {
      const res = await notificationsApi.unreadCount();
      return res.data.count;
    },
    refetchInterval: 60_000,
  });
}

export function useMarkRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => notificationsApi.markRead(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: notificationKeys.all });
    },
  });
}

export function useMarkAllRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => notificationsApi.markAllRead(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: notificationKeys.all });
    },
  });
}
